export function isMissingSipConfigError(error) {
  const message = String(error?.message || '');
  return error?.status === 404
    || message.includes('API Error (404)')
    || message.includes('SIP config not found');
}

export function sipDomainAssigned(data) {
  if (!data || typeof data !== 'object') return false;
  return Boolean(String(data.sipDomainSid || '').trim() || String(data.domainFqdn || '').trim());
}
